<template>
  <a-drawer
    :visible="visible"
    title="Selecciona tus filtros avanzados"
    destroy-on-close
    placement="right"
    width="480"
    :body-style="{ padding: 0, height: 'calc(100% - 55px)' }"
    :maskClosable="false"
    @close="handleCloseDrawer"
  >
    <custom-scrollbar height="calc(100% - 72px)" style="display: flex">
      <div class="modal__body">
        <p class="drawer__body--subtitle">
          Aplica filtros para detectar tickets de las empresas y campañas.
        </p>

        <div v-if="!empty">
          <a-form layout="vertical" ref="formRef" :model="formState">
            <a-form-item label="Colas">
              <selector-tags-all-options
                v-model:values="formState.queues"
                :options="options.queues"
                placeholder="Seleccione"
                placeholder-tag-max="Todas las colas"
              />
            </a-form-item>

            <a-form-item label="Canales">
              <selector-tags-all-options
                v-model:values="formState.channel"
                :options="channelOptions.filter(el => el.value != '')"
                placeholder="Seleccione"
                placeholder-tag-max="Todos los canales"
              />
              <!-- <a-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model:value="formState.channel"
                @change="formState.identifier = ''"
                :options="channelOptions"
                placeholder="Seleccione"
                style="width: 100%"
              /> -->
            </a-form-item>

            <a-form-item label="Todos los identificadores de canales">
              <!-- :options="options.identifiers" -->
              <a-select
                :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                v-model:value="formState.identifier"
                placeholder="Seleccione"
                style="width: 100%"
              >
                <a-select-option v-for="identifier in identifiersFilter" :key="identifier.id">
                  <div class="select_identifiers">
                    <img
                      v-if="identifier.channel"
                      height="16"
                      width="16"
                      :src="identifier.channel.icon"
                      :alt="identifier.channel.id"
                    />
                    <span> {{ nameIdentifier(identifier) }}&nbsp; </span>
                    <span v-if="showIdentifierDetail(identifier, identifier?.channel?.id)">
                      ({{ identifier.associate }})
                    </span>
                  </div>
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="Estado de tickets">
              <selector-tags-all-options
                v-model:values="formState.ticketStates"
                :options="options.ticketStates"
                placeholder="Seleccione"
                placeholder-tag-max="Todas los estados"
              />
            </a-form-item>

            <a-form-item label="Etiquetas">
              <selector-tags-all-options
                v-model:values="formState.tags"
                :options="options.tags"
                placeholder="Seleccione"
                placeholder-tag-max="Todas las etiquetas"
              />
            </a-form-item>

            <p class="drawer__body--title" style="margin-bottom: 10px">Tipificaciones:</p>
            <a-form-item label="Última tipificación">
              <selector-tags-all-options
                v-model:values="formState.contact_types"
                :options="options.contact_types"
                placeholder="Seleccione"
                placeholder-tag-max="Todas las tipificaciones"
              />
            </a-form-item>

            <template v-if="userData?.profile !== ProfileTypes.Agent">
              <p class="drawer__body--title">Selecciona los usuarios en gestión:</p>
              <agents-picker
                :value="formState.users"
                @update:value="formState.users = $event"
                :items="usersItems"
              />
            </template>

            <div class="visibility__component">
              <div class="visibility__component--header">
                <p class="drawer__body--title">Visualización de tickets de estrategias</p>
                <a-tooltip>
                  <template #title>{{
                    !formState.switchStrategies ? "Activar" : "Desactivar"
                  }}</template>
                  <a-switch
                    v-model:checked="formState.switchStrategies"
                    @change="handleChangeSwitchStrategies"
                    style="margin-left: 12px"
                  />
                </a-tooltip>
              </div>
              <div class="visibility__component--content">
                <InfoCircleOutlined class="info-circle" />
                <div>
                  <p>
                    Recuerda que al activar esta opción se mostraran los tickets con estado 'En
                    cola' que están ocultos debido a la falta de respuesta por parte del contacto.
                  </p>
                  <a-checkbox
                    v-model:checked="formState.checkedStrategies"
                    :disabled="!formState.switchStrategies"
                    >Listar solo tickets ocultos</a-checkbox
                  >
                </div>
              </div>
            </div>

            <!-- <div class="visibility__component">
              <div class="visibility__component--header">
                <p class="drawer__body--title">Visualización de tickets de estrategias de SMS</p>
                <a-tooltip>
                  <template #title>{{ !formState.switchSMS ? "Activar" : "Desactivar" }}</template>
                  <a-switch
                    v-model:checked="formState.switchSMS"
                    @change="handleChangeSwitchSms"
                    style="margin-left: 12px"
                  />
                </a-tooltip>
              </div>
              <div class="visibility__component--content">
                <InfoCircleOutlined class="info-circle" />
                <div>
                  <p>Recuerda que al activar esta opción se mostrarán los tickets de SMS.</p>
                  <a-checkbox
                    v-model:checked="formState.checkedSMS"
                    :disabled="!formState.switchSMS"
                    >Mostrar solo tickets ocultos</a-checkbox
                  >
                </div>
              </div>
            </div> -->
          </a-form>
        </div>

        <div class="container__empty" v-else>
          <img :src="maskGroupImage" alt="Vacio" />
          <p class="text--top">Podrás filtrar sobre tus <br />tickets activos o históricos</p>
        </div>
      </div>
    </custom-scrollbar>

    <div class="footer">
      <a-button class="footer__button" @click="handleClearFilters"> Limpiar </a-button>
      <a-button type="primary" @click="handleApplyFilters"> Aplicar </a-button>
    </div>
  </a-drawer>
</template>
<script>
import { computed, ref, createVNode } from "vue";
import { useStore } from "vuex";
import { Modal, message } from "ant-design-vue";
import { QuestionCircleOutlined, InfoCircleOutlined } from "@ant-design/icons-vue";
import { TicketState, ProfileTypes } from "@/app/shared/utils/enums";
import CustomScrollbar from "@/app/shared/components/organisms/CustomScrollbar.vue";
import AgentsPicker from "@/app/shared/components/pickers/AgentsPicker.vue";

import maskGroupImage from "@/app/contacts/assets/maskGroup.svg?url";

import { ChannelType } from "@/app/shared/utils/enums";
import SelectorTagsAllOptions from "@/app/shared/components/selectors/SelectorTagsAllOptions.vue";

export default {
  components: {
    CustomScrollbar,
    AgentsPicker,
    SelectorTagsAllOptions,
    InfoCircleOutlined,
  },
  props: {
    visible: {
      required: true,
      type: Boolean,
    },
    empty: {
      required: false,
      type: Boolean,
      default: false,
    },
    selectedFilters: {
      required: false,
      type: Object,
    },
  },
  setup(props, { emit }) {
    const store = useStore();
    const SelectAllQueues = ref(false);
    const SelectAllTags = ref(false);
    const SelectAllContactTypes = ref(false);
    const checkedStrategies = ref(false);
    const SUA = "SUA";

    const channelOptions = computed(() => store.getters["getTicketManagerChannels"]);
    const advancedFiltersData = computed(() => store.getters["getAdvancedFiltersData"]);
    const userData = computed(() => store.getters["getDataUser"]);
    const identifiersFilter = computed(() => {
      const channelsSelected = channelOptions.value.filter((el) =>
        formState.value.channel.includes(el.value)
      );
      let identifiers = options.identifiers;

      if (channelsSelected.length > 0) {
        const channelIds = channelsSelected
          .map((channel) => channel.id.toString())
          .flat();

        identifiers = options.identifiers.filter((item) =>
          channelIds.includes(item.channel.id.toString())
        );
      }

      if (identifiers?.length > 0) {
        return [{ id: "", alias: "Todos los identificadores" }, ...identifiers];
      } else return [];
    });
    let options = {};

    if (advancedFiltersData.value) {
      options = {
        queues: advancedFiltersData.value.queues.map((queue) => ({
          value: queue.id,
          label: queue.name,
        })),
        identifiers: advancedFiltersData.value.channels_customers,
        // identifiers: [
        //   {
        //     id: "1",
        //     channel: {
        //       id: "2",
        //       icon: "http://scorev2bucket.obs.sa-peru-1.myhuaweicloud.com/channels/sms.png",
        //     },
        //     identifier: "(+51 983928212)",
        //     alias: "Rimac Staging",
        //   },
        // ],
        ticketStates: [
          { value: TicketState.wait, label: "En cola" },
          { value: TicketState.delivered, label: "Asignado" },
          { value: TicketState.finished, label: "Resuelto" },
          // { value: TicketState.noLabels, label: "Sin Etiquetas" },
        ],
        tags: advancedFiltersData.value.tags.map((tag) => ({ value: tag.id, label: tag.name })),
        contact_types: [
          { value: "GCD", label: "Contacto directo" },
          { value: "GCI", label: "Contacto indirecto" },
          { value: "GNC", label: "No contacto" },
          { value: "without_group", label: "Sin Tipificaciones" },
        ],
      };
    }

    const formRef = ref(null);
    const formState = ref({
      queues:
        props.selectedFilters?.queues?.length > 0
          ? props.selectedFilters?.queues
          : options.queues?.map((el) => el.value) || [],
      ticketStates:
        props.selectedFilters?.ticketStates?.length > 0
          ? props.selectedFilters?.ticketStates
          : options.ticketStates?.map((el) => el.value) || [],
      tags:
        props.selectedFilters?.tags?.length > 0
          ? props.selectedFilters?.tags
          : options.tags?.map((el) => el.value) || [],
      users: props.selectedFilters?.users
        ? advancedFiltersData.value.users.filter((user) =>
            props.selectedFilters?.users.includes(user.id)
          )
        : [],
      channel:
        props.selectedFilters?.channel?.length > 0
          ? props.selectedFilters?.channel
          : channelOptions.value?.map((el) => el.value) || [],
      identifier: props.selectedFilters?.identifier || "",
      contact_types:
        props.selectedFilters?.contact_types?.length > 0
          ? props.selectedFilters?.contact_types
          : options.contact_types?.map((el) => el.value) || [],
      switchStrategies: props.selectedFilters?.switchStrategies || false,
      checkedStrategies: props.selectedFilters?.checkedStrategies || false,
    });

    if (props.selectedFilters?.withoutUser) {
      formState.value.users = [
        ...formState.value.users,
        { id: SUA, fullname: "Sin usuario asignado" },
      ];
    }

    const handleApplyFilters = () => {
      formRef.value.validateFields().then(() => {
        const { users, ...filters } = formState.value;

        const formFields = {
          ...filters,
          channels_id: formState.value.channel,
          withoutUser: noAssignedUserSelected.value,
          users: users.filter((el) => el.id != SUA).map((user) => user.id),
        };

        Object.values(formFields).flat().length === 0
          ? emit("clear-filters")
          : emit("apply-filters", formFields);
      });

      // emit("close-drawer");
    };

    const handleClearFilters = () => {
      emit("clear-filters");
      message.success("Se han limpiado los filtros correctamente");

      emit("close-drawer");
    };

    const handleCloseDrawer = () => {
      if (Object.values(formState.value).flat().length !== 0) {
        Modal.confirm({
          title: `¿Deseas descartar los cambios realizados?`,
          content: "Recuerda que si no guardas los cambios registrados, estos se perderán.",
          icon: createVNode(QuestionCircleOutlined),
          centered: true,
          onOk: () => emit("close-drawer"),
          okText: "Sí, descartar cambios",
          cancelText: "No, seguir editando",
        });
      } else {
        emit("close-drawer");
      }
    };

    const channelsDetails = [
      ChannelType.Sms,
      ChannelType.Whatsapp,
      ChannelType.Ivr,
      ChannelType.Inbound,
      ChannelType.VoiceInbound,
      ChannelType.Email,
    ];

    const nameIdentifier = (identifier) => {
      if (identifier?.channel?.id == ChannelType.Voice) return "Llamada saliente";
      else if (channelsDetails.includes(identifier?.channel?.id))
        return identifier.alias || "Sin Alias";
      else return identifier.alias || identifier.associate;
    };

    const showIdentifierDetail = (identifier, channelId) => {
      return (
        channelsDetails.includes(channelId) &&
        identifier.associate &&
        identifier.associate != identifier.alias
      );
    };

    const usersItems = computed(() => {
      const users = advancedFiltersData.value?.users || [];
      return [...users, { id: SUA, fullname: "Sin usuario asignado" }];
    });

    const noAssignedUserSelected = computed(() => {
      const index = formState.value.users.findIndex((el) => el.id == SUA);
      return index != -1;
    });

    const handleChangeSwitchStrategies = (value) => {
      if (!value) formState.value.checkedStrategies = false;
    };

    return {
      ProfileTypes,
      advancedFiltersData,
      channelOptions,
      userData,
      options,
      formRef,
      formState,
      identifiersFilter,
      handleApplyFilters,
      handleClearFilters,
      handleCloseDrawer,
      maskGroupImage,
      nameIdentifier,
      showIdentifierDetail,
      usersItems,
      noAssignedUserSelected,
      handleChangeSwitchStrategies,
      SUA,
    };
  },
};
</script>

<style lang="sass" scoped>
.modal
  &__body
    margin: 12px 24px

.footer
  display: flex
  align-items: center
  justify-content: flex-end
  margin-top: 8px
  padding: 12px 16px
  border-top: $border-normal

  &__display
    width: 100%
    font-size: 12px
    color: $gray-7

  &__button
    margin-right: 12px

.drawer__body
  &--title
    font-weight: 600
    color: $gray-9
    margin-bottom: 0

  &--subtitle
    font-weight: 400
    color: $gray-8

.container__empty
  text-align: center
  display: flex
  flex-direction: column
  height: calc(100% - 60px)
  align-items: center
  justify-content: center

  img
    width: 100px

.text--bottom
  margin-top: 0

.text--top
  margin-top: 20px
  margin-bottom: 0

.select_identifiers
  display: flex
  align-items: center
  img
    margin-right: 8px

.visibility__component
  border-radius: 10px
  background: #0000000A
  padding: 10px
  margin-bottom: 13px
  border: 2px solid
  border-color: $gray-5

  &--header
    display: flex
    justify-content: space-between
    font-weight: 600
    color: $gray-9
    margin-bottom: 9px
  &--content
    font-weight: 400
    font-size: 14px
    color: $gray-8
    display: flex
    flex-wrap: nowrap
    align-items: baseline

.info-circle
  font-size: 14px
  color: #51555A
  margin-right: 10px
</style>
